import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import { Dialog, Disclosure, Popover, Transition } from '@headlessui/react'
import {
    ArrowPathIcon,
    Bars3Icon,
    ChartPieIcon,
    CursorArrowRaysIcon,
    FingerPrintIcon,
    SquaresPlusIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline'
import { ChevronDownIcon, PhoneIcon, PlayCircleIcon } from '@heroicons/react/20/solid'
import { Helmet, HelmetProvider } from "react-helmet-async";
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
//import logo from "../imagenes/powerbit.svg";


import { faMoon } from "@fortawesome/free-regular-svg-icons";
import { IoMoon } from "react-icons/io5";
import { IoSunny } from "react-icons/io5";
import { IconContext } from "react-icons";
import Cookies from 'js-cookie';
import Logout from "./Logout";
import { isAndroid, isIOS, isMobile, isTablet, isBrowser } from 'react-device-detect';

export const Nav = ({ visible, setVisible, handleAgregar, handleClose, installEvent, isStandalone }) => {







    const products = [
        { name: 'Analytics', description: 'Get a better understanding of your traffic', href: '#', icon: ChartPieIcon },
        { name: 'Engagement', description: 'Speak directly to your customers', href: '#', icon: CursorArrowRaysIcon },
        { name: 'Security', description: 'Your customers’ data will be safe and secure', href: '#', icon: FingerPrintIcon },
        { name: 'Integrations', description: 'Connect with third-party tools', href: '#', icon: SquaresPlusIcon },
        { name: 'Automations', description: 'Build strategic funnels that will convert', href: '#', icon: ArrowPathIcon },
    ]
    const callsToAction = [
        { name: 'Watch demo', href: '#', icon: PlayCircleIcon },
        { name: 'Contact sales', href: '#', icon: PhoneIcon },
    ]

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }


    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)




    useEffect(() => {
        const popup = document.querySelector('.popup__modal');

        if (popup) {
            popup.style.display = mobileMenuOpen ? 'none' : 'flex';
        }
    }, [mobileMenuOpen]);



    useEffect(() => {

    }, []);//setProductos


    return (




        <header className="nav__fondo">
            <nav className="mx-auto flex max-w-7xl items-center justify-between lg:px-8" aria-label="Global">
                <div className="flex lg:flex-1">
                    <Link to={process.env.PUBLIC_URL} className="-m-1.5 p-1.5">
                        <span className="sr-only">El Cazador GYM</span>
                        <img
                            class="h-28 w-auto"
                            src={require("../imagenes/elcazadorgym-logo1.png")}
                            alt="El Cazador Gym"
                        />
                        {/*require no anda con svg??? */}
                    </Link>
                </div>
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        className="m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <Popover.Group className="hidden lg:flex lg:gap-x-12">

                    <Link to={process.env.PUBLIC_URL} className=" hidden text-sm leading-6 font-semibold text-[#d40000] hover:text-[#b70100]">Fitness control</Link>





                </Popover.Group>
                <div className="hidden lg:flex lg:flex-1 lg:justify-end">

                    <div className="pr-2 ">

                    </div>
                    <Logout />
                    {/*botonCarrito()*/}

                </div>
            </nav>
            <Dialog as="div" className="lg:hidden z-50" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className="fixed inset-0  bg-[#0f0f0f] dark:bg-[#0f0f0f]" />
                <Dialog.Panel className="fixed inset-y-0 right-0  w-full overflow-y-auto bg-powerbit-top px-2 py-0 lg:max-w-sm lg:ring-1 lg:ring-gray-900/10">
                    <div className="flex items-center justify-between">
                        <Link to={process.env.PUBLIC_URL} className="-m-1.5 p-1.5" onClick={() => setMobileMenuOpen(false)}>
                            <span className="sr-only">El Cazador GYM</span>

                            <img
                                class="h-28 w-auto"
                                src={require("../imagenes/elcazadorgym-logo1.png")}
                                alt="El Cazador Gym"
                            />
                        </Link>
                        <button
                            type="button"
                            className="m-2.5 rounded-md p-2.5 text-gray-700 mr-2.5"
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Cerrar menu</span>
                            <XMarkIcon className=" h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root mx-3">

                        <div className="space-y-2 py-6 hidden">

                            <Link to={process.env.REACT_APP_URL_FOLDER + "/"} onClick={() => setMobileMenuOpen(false)} className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-black dark:text-[#c3c3cc] hover:bg-white">Inicio</Link>


                        </div>
                        {
                            /*isMobile && installEvent && !isStandalone && (
                                <div className="space-y-2 py-6">

                                    <Link to={process.env.PUBLIC_URL} onClick={handleAgregar} className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-black dark:text-[#c3c3cc] hover:bg-white"> Agregar a pantalla principal</Link>


                                </div>
                            )
                                */}



                        {isMobile && !isStandalone && (
                            <Link
                                to={process.env.PUBLIC_URL}
                                onClick={() => {
                                    setMobileMenuOpen(false);
                                    handleAgregar();
                                }}
                                className="pt-3 pb-3  block rounded-lg px-3 py-2 text-base  leading-7   hover:bg-[#b70100] hover:text-[#fff] "
                            >
                                Agregar acceso directo
                            </Link>
                        )}




                        <div className="border-t mt-2 border-gray-600">

                            <div className="pt-4 pb-3 mx-1  ">



                                <Logout />



                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </header >
    )
}